import { apiClient } from "../helpers/common";
//import { setUserDetails } from "./actions";


const sendRespone = async (data) => {
    const res = await data.json();
    return { res, status: data.status };
}


export const adminLogin = async (data) => {
    const { email, password } = data;
    const apiRequest = await apiClient('admin-login', {
        method: 'POST',
        body: { email, password }
    });
    const { status } = apiRequest;
 
    return apiRequest;
    // const res = await sendRespone(apiRequest);
    // return res;
}
